"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const config_1 = require("config");
const utils_1 = require("utils");
const ContactPatientForm_1 = __importDefault(require("../forms/ContactPatientForm"));
const reducer_1 = require("../reducer");
function DeclinedAccessLoanAvailable({ applicationInfo, sendExternalReferencesCommunication, declinedCreditApplication, }) {
    const callbackUrl = (0, config_1.makePath)(config_1.CONSUMER_APP_URL, config_1.PATH.CREDIT_PORTAL, config_1.PATH.APPLICANTS) +
        '?action=continue';
    const handleSubmit = (data) => {
        const requestBody = {
            ...data,
            application_callback_url: callbackUrl,
        };
        return sendExternalReferencesCommunication(declinedCreditApplication?.applicationId, requestBody);
    };
    const history = (0, react_router_dom_1.useHistory)();
    const handleSubmitSuccess = () => {
        (0, utils_1.toastSuccess)('Successfully sent application information to customer');
        history.push(config_1.PATH.MERCHANT_PORTAL);
    };
    const handleCancel = () => {
        history.push(config_1.PATH.MERCHANT_PORTAL);
    };
    const { email, primaryPhone: sms } = applicationInfo;
    return ((0, jsx_runtime_1.jsx)("div", { className: "declined-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "content", children: [(0, jsx_runtime_1.jsx)("h1", { className: "first-title", style: { lineHeight: '38px', textAlign: 'center' }, children: "Credit Application" }), (0, jsx_runtime_1.jsx)("p", { children: "We were unable to approve you for an Alphaeon Credit Card. You will receive an explanation letter in 7-10 business days." }), (0, jsx_runtime_1.jsxs)("p", { children: ["However, ", (0, jsx_runtime_1.jsx)("b", { children: "THE PATIENT MAY QUALIFY" }), " for the Alphaeon Credit Access Program"] }), (0, jsx_runtime_1.jsxs)("p", { children: ["If the patient would like to apply for the Access Program, Alphaeon can send the application link to the patient's email.", "Please select the patient's preferred method of contact below."] }), (0, jsx_runtime_1.jsx)(ContactPatientForm_1.default, { initialValues: (0, utils_1.contactFormInitialValues)({ email, sms }), onSubmit: handleSubmit, handleCancel: handleCancel, onSubmitSuccess: handleSubmitSuccess, onSubmitFail: utils_1.flashSubmitFailure })] }) }));
}
function mapStateToProps(state) {
    return {
        applicationInfo: reducer_1.selectors.applicationInfo(state),
        declinedCreditApplication: reducer_1.selectors.approvedCreditApplication(state),
    };
}
const mapApiAuthToProps = {
    sendExternalReferencesCommunication: apiActions.sendExternalReferencesCommunication,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(DeclinedAccessLoanAvailable);
